export const WIDTH_SM = 544;
export const WIDTH_MD = 768;
export const WIDTH_LG = 1012;
export const WIDTH_XL = 1280;
export const WIDTH_XXL = 1680;

export const DEVICE_TYPES = {
  MOBILE: "MOBILE",
  TABLET: "TABLET",
  DESKTOP: "DESKTOP",
  WIDE: "WIDE",
};
